import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import bloggerService from '../../services/blogger';

const initialState = {
  loading: false,
  bloggers: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchBloggers = createAsyncThunk(
  'blogger/fetchBloggers',
  (params = {}) => {
    return bloggerService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const bloggerSlice = createSlice({
  name: 'blogger',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBloggers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBloggers.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.bloggers = payload.data;
      state.meta = payload.meta;
      state.params.page = payload.meta.current_page;
      state.params.perPage = payload.meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchBloggers.rejected, (state, action) => {
      state.loading = false;
      state.bloggers = [];
      state.error = action.error.message;
    });
  },
});

export default bloggerSlice.reducer;
